import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { Loading, ModalToggle } from 'ck-ui';
import styles from './ProductSizeChart.module.scss';

const ProductSizeChart = ({ brand, gender, category, subcategories }) => {
  const [content, setContent] = useState(null);
  const [mounted, setMounted] = useState(false);

  const parseData = (html, brandName = 'general') => {
    const htmlDom = window.$.parseHTML(html);
    const ele = window.$(htmlDom).find('[data-component="NewSizeChart"]');
    const props = ele.data('props');
    let categoryName = category;

    if (!props[brandName] || !props[brandName][gender]) {
      // if there is no brand data or the brand's gender no data then use general brand instead
      brandName = 'general';
    }

    const subcategory = subcategories?.split(',').find(d => props[brandName][gender]?.findIndex(item => item.category === d) !== -1);
    if (subcategory) {
      categoryName = subcategory;
    }
    // if there is no category and subcategory data then use general brand instead
    if (!subcategory && props[brandName][gender].findIndex((d) => d.category === category) === -1) {
      brandName = 'general';
    }

    props.params = {
      brand: brandName,
      gender,
      category: categoryName,
      noLayout: true,
    };
    ele.attr('data-props', JSON.stringify(props));
    setContent(ele.prop('outerHTML'));
  };

  const getContent = async () => {
    try {
      const { data: html } = await axios.get(`http://${window.location.hostname}/pages/general-size-chart`, {
        responseType: 'text/html',
      });
      parseData(html, brand);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn(e);
    }
  };
  useEffect(() => {
    if (!content || !mounted) return;
    document.dispatchEvent(new Event('renderSizeChart'));
  }, [content, mounted]);
  return (
    <ModalToggle
      href="#"
      label={<><span className="icon icon-info" /> Size Chart</>}
      modalProps={{ isTouchFullScreen: true }}
      onOpen={() => {
        if (!content) {
          getContent();
        }
        setMounted(true);
      }}
      onClose={() => {
        setMounted(false);
      }}
    >
      <div className={styles.root}>
        {content ? (
          // eslint-disable-next-line react/no-danger
          <div dangerouslySetInnerHTML={{ __html: content }} />
        ) : (
          <Loading isLoading />
        )}
      </div>
    </ModalToggle>
  );
};

ProductSizeChart.propTypes = {
  brand: PropTypes.string.isRequired,
  gender: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  subcategories: PropTypes.string.isRequired
};

export { ProductSizeChart };
